import { render, staticRenderFns } from "./Workwx.vue?vue&type=template&id=5fef83f6&"
import script from "./Workwx.vue?vue&type=script&lang=js&"
export * from "./Workwx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports